import { request } from '@/utils/request';
import type { ApiResponse, WrappedResult } from './types';

const waybillsApi = {
  getAll(params?: cyrian.api.waybills.GetParams): ApiResponse<WrappedResult<cyrian.api.waybills.Waybill[]>> {
    return request({
      method: 'get',
      url: '/waybills',
      params,
    });
  },
  get(id: number): ApiResponse<WrappedResult<cyrian.api.waybills.Waybill>> {
    return request({
      method: 'get',
      url: `/waybills/${id}`,
    });
  },
  create(data: cyrian.api.waybills.Params): ApiResponse<WrappedResult<cyrian.api.waybills.Waybill>> {
    return request({
      method: 'post',
      url: '/waybills',
      data,
    });
  },
  update(id: number, data: cyrian.api.waybills.Params): ApiResponse<WrappedResult<cyrian.api.waybills.Waybill>> {
    return request({
      method: 'patch',
      url: `/waybills/${id}`,
      data,
    });
  },
  bulkUpdate(
    data: cyrian.api.waybills.WaybillBulkUpdateFormData,
  ): ApiResponse<WrappedResult<cyrian.api.waybills.Waybill[]>> {
    return request({
      method: 'post',
      url: '/waybills/bulk/update',
      data,
    });
  },
  bulkDelete(data: { ids: number[] }): ApiResponse<WrappedResult<any>> {
    return request({
      method: 'post',
      url: '/waybills/bulk/delete',
      data,
    });
  },
  delete(id: number): ApiResponse<WrappedResult<any>> {
    return request({
      method: 'delete',
      url: `/waybills/${id}`,
    });
  },

  createWaybillsFromExcel(data: cyrian.api.waybills.WaybillFromExcelFormData): ApiResponse<WrappedResult<any>> {
    return request({
      method: 'post',
      url: '/waybills/create-from-excel',
      headers: {
        Accept: '*/*',
        'Content-Type': 'multipart/form-data',
      },
      timeout: 90000,
      data,
    });
  },
  linkFarmersFromExcel(data: FormData): ApiResponse<WrappedResult<any>> {
    return request({
      method: 'post',
      url: '/waybills/link-farmers-from-excel',
      headers: {
        Accept: '*/*',
        'Content-Type': 'multipart/form-data',
      },
      timeout: 90000,
      data,
    });
  },

  linkFarmersFromExcelBatch(
    data: FormData,
  ): ApiResponse<WrappedResult<cyrian.api.waybills.LinkFarmersFromExcelBatchData>> {
    return request({
      method: 'post',
      url: '/waybills/link-farmers-from-excel-batch',
      headers: {
        Accept: '*/*',
        'Content-Type': 'multipart/form-data',
      },
      timeout: 600000,
      data,
    });
  },

  getWeighingAnalyses(
    waybillId: number,
    params: cyrian.api.waybillsWeighingAnalyses.GetParams,
  ): ApiResponse<WrappedResult<cyrian.api.waybillsWeighingAnalyses.WaybillWeighingAnalysis[]>> {
    return request({
      method: 'get',
      url: `/waybills/${waybillId}/weighing-analyses`,
      params,
    });
  },
  createWeighingAnalysis(
    waybillId: number,
    data: any,
  ): ApiResponse<WrappedResult<cyrian.api.waybillsWeighingAnalyses.WaybillWeighingAnalysis>> {
    return request({
      method: 'post',
      url: `/waybills/${waybillId}/weighing-analyses`,
      data,
    });
  },

  addLots(waybillId: number, lotIds: number[]): ApiResponse<WrappedResult<cyrian.api.waybills.Waybill>> {
    return request({
      method: 'post',
      url: `/waybills/${waybillId}/lots`,
      data: { lotIds },
    });
  },
};

export default waybillsApi;
